module.exports = __webpack_public_path__ + "static/media/hamburger.18fb7dec.svg";